import WIX_PARAM from './keys';
import { BADGE_LAYOUT, BADGE_SIZE } from '../badges';

export type Font = {
  editorKey: string;
  themeName: string;
};

const PARAGRAPH_2_FONT = { editorKey: 'font_8', themeName: 'Body-M' };
const HEADING_2_FONT = { editorKey: 'font_5', themeName: 'Heading-M' };
const HEADING_6_FONT = { editorKey: 'font_6', themeName: 'Heading-S' };

export const fontsDefaults = {
  [WIX_PARAM.BUTTON_FONT]: PARAGRAPH_2_FONT,
  [WIX_PARAM.TEXT_PRIMARY_FONT]: PARAGRAPH_2_FONT,
  [WIX_PARAM.TEXT_SECONDARY_FONT]: PARAGRAPH_2_FONT,
  [WIX_PARAM.TEXT_TITLE_FONT]: HEADING_2_FONT,
  [WIX_PARAM.TEXT_POST_TITLE_FONT]: HEADING_2_FONT,
  [WIX_PARAM.TEXT_POST_DESCRIPTION_FONT]: PARAGRAPH_2_FONT,
  [WIX_PARAM.TEXT_STATISTICS_FONT]: PARAGRAPH_2_FONT,
  [WIX_PARAM.BADGE_FONT]: PARAGRAPH_2_FONT,
  [WIX_PARAM.PW_RESPONSIVE_NAME_FONT]: PARAGRAPH_2_FONT,
  [WIX_PARAM.PW_RESPONSIVE_FF_FONT]: PARAGRAPH_2_FONT,
  [WIX_PARAM.PW_RESPONSIVE_BUTTON_FONT]: PARAGRAPH_2_FONT,
  [WIX_PARAM.SECTION_TITLE_FONT]: HEADING_6_FONT,
  [WIX_PARAM.SECTION_DESCRIPTION_FONT]: PARAGRAPH_2_FONT,
  [WIX_PARAM.FIELD_LABEL_FONT]: PARAGRAPH_2_FONT,
  [WIX_PARAM.FIELD_TEXT_FONT]: PARAGRAPH_2_FONT,
  [WIX_PARAM.FIELD_PLACEHOLDER_FONT]: PARAGRAPH_2_FONT,
  [WIX_PARAM.BADGE_DESCRIPTION_FONT]: PARAGRAPH_2_FONT,
  [WIX_PARAM.EMPTY_STATE_TITLE_FONT]: PARAGRAPH_2_FONT,
  [WIX_PARAM.EMPTY_STATE_DESCRIPTION_FONT]: PARAGRAPH_2_FONT,
  [WIX_PARAM.TEXT_LOGGED_OUT_TITLE_FONT]: HEADING_2_FONT,
  [WIX_PARAM.TEXT_LOGGED_OUT_DESCRIPTION_FONT]: PARAGRAPH_2_FONT,
  [WIX_PARAM.TEXT_NO_MEMBERS_TITLE_FONT]: HEADING_2_FONT,
  [WIX_PARAM.TEXT_NO_MEMBERS_DESCRIPTION_FONT]: PARAGRAPH_2_FONT,
};

export default {
  [WIX_PARAM.BOX_COLOR]: 'color-1',
  [WIX_PARAM.PAGE_COLOR]: 'color-1',
  [WIX_PARAM.BORDER_COLOR]: 'color-5',
  [WIX_PARAM.BORDER_WIDTH_1]: 1,
  [WIX_PARAM.BORDER_WIDTH_2]: 0,
  [WIX_PARAM.FOLLOWERS_BUTTON_BORDER_WIDTH]: 1,

  [WIX_PARAM.BUTTON_FONT_COLOR]: 'color-5',
  [WIX_PARAM.BUTTON_PRIMARY_TEXT_COLOR]: 'color-5',
  [WIX_PARAM.BUTTON_SECONDARY_TEXT_COLOR]: 'color-5',
  [WIX_PARAM.BUTTON_OPACITY_AND_COLOR]: 'color-8',
  [WIX_PARAM.FOLLOWERS_BUTTON_BORDER_OPACITY_AND_COLOR]: 'color-8',

  [WIX_PARAM.TEXT_PRIMARY_COLOR]: 'color-5',
  [WIX_PARAM.TEXT_SECONDARY_COLOR]: 'color-5',
  [WIX_PARAM.TEXT_TITLE_COLOR]: 'color-5',
  [WIX_PARAM.TEXT_POST_TITLE_COLOR]: 'color-5',
  [WIX_PARAM.TEXT_POST_DESCRIPTION_COLOR]: 'color-5',
  [WIX_PARAM.POST_BACKGROUND_COLOR]: 'color-1',
  [WIX_PARAM.POST_BORDER_COLOR]: 'color-5',
  [WIX_PARAM.TEXT_POST_HOVER_COLOR]: 'color-5',
  [WIX_PARAM.TEXT_STATISTICS_COLOR]: 'color-5',

  [WIX_PARAM.BADGE_LAYOUT]: BADGE_LAYOUT.NAME_AND_ICON,
  [WIX_PARAM.BADGE_SIZE]: BADGE_SIZE.SMALL,
  [WIX_PARAM.BADGE_CORNER_RADIUS]: 10,
  [WIX_PARAM.SHOW_BADGE_BACKGROUND]: true,

  [WIX_PARAM.PW_RESPONSIVE_NAME_COLOR]: '#FFFFFF',
  [WIX_PARAM.PW_RESPONSIVE_FF_COLOR]: '#FFFFFF',
  [WIX_PARAM.PW_RESPONSIVE_BUTTON_COLOR]: '#FFFFFF',
  [WIX_PARAM.PW_COVER_COLOR]: 'color-8',

  [WIX_PARAM.POST_TEXT_PADDING]: 30,
  [WIX_PARAM.POST_CARD_WIDTH]: 288,
  [WIX_PARAM.POST_CARD_MARGIN]: 28,
  [WIX_PARAM.POST_CARD_HEIGHT]: 250,

  // CUSTOM PROFILE
  [WIX_PARAM.SPACE_FROM_TOP]: 30,
  [WIX_PARAM.SPACE_BETWEEN_SECTIONS]: 30,
  [WIX_PARAM.SPACE_OVERVIEW_INFORMATION]: 16,
  [WIX_PARAM.DIVIDERS_WIDTH]: 1,
  [WIX_PARAM.DIVIDERS_COLOR]: 'color-5',
  [WIX_PARAM.SECTION_TITLE_COLOR]: 'color-5',
  [WIX_PARAM.SECTION_DESCRIPTION_COLOR]: 'color-5',
  [WIX_PARAM.FIELD_LABEL_COLOR]: 'color-4',
  [WIX_PARAM.FIELD_TEXT_COLOR]: 'color-5',
  [WIX_PARAM.FIELD_PLACEHOLDER_COLOR]: 'color-3',
  [WIX_PARAM.BADGE_DESCRIPTION_COLOR]: 'color-5',
  [WIX_PARAM.EMPTY_STATE_TITLE_COLOR]: 'color-5',
  [WIX_PARAM.EMPTY_STATE_DESCRIPTION_COLOR]: 'color-3',

  [WIX_PARAM.SHOW_FOLLOW_BUTTON]: true,
  [WIX_PARAM.SHOW_BADGES]: true,
  [WIX_PARAM.SHOW_MESSAGE_BUTTON]: true,
  [WIX_PARAM.SHOW_FOLLOWERS_FOLLOWING]: true,
  [WIX_PARAM.DEFAULT_COVER_PHOTO_OPACITY]: 60,
  [WIX_PARAM.FOLLOWERS_BUTTON_CORNER_RADIUS]: 0,
  [WIX_PARAM.MEMBERS_BUTTON_CORNER_RADIUS]: 0,
  [WIX_PARAM.MEMBERS_CARD_CORNER_RADIUS]: 0,

  ...fontsDefaults,
};
